<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-radio-group v-model="config[field.key]" class="radio-group" type="flex" @change="change">
                <div v-for="(item,index) in field['radio-list']" :key="index" class="radio-item">
                    <el-radio :label="item.value"><img :src="item.url" alt="" :width="field.width"></el-radio>
                </div>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="背景图：" label-width="110px">
            <image-uploader :uploadedImg="config.property_data.background_image" @uploaded="handleUpload"
                            class="small-image" :tip="memo"></image-uploader>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
    .radio-group {
        .radio-item {
            display: inline-block;
            padding-right: 20px;
            margin-bottom: 10px;

            img {
                border: 1px solid #E3E7EE;
            }

            [aria-checked=true] img {
                border: 1px solid #4A8EF7;
            }
        }

    }
</style>

<script>

  import ImageUploader from '@/components/ImageUploader.vue';

  export default {
    name: 'tms-type-personal-info',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        radio: 0,
        memo: '建议宽度：750px*200px'
      }
    },

    watch: {
      styleType() {
        this.change(this.config[this.field.key]);
      }
    },

    computed: {
      styleType() {
        return this.config[this.field.key];
      }
    },

    components: {
      ImageUploader
    },

    mounted() {
      this.change(this.config[this.field.key]);
    },

    methods: {
      change(val) {
        switch (val) {
          case 1:
            this.memo = '建议宽度：750px*200px';
            break;
          case 2:
            this.memo = '建议宽度：750px*274px';
            break;
          case 3:
            this.memo = '建议宽度：750px*240px';
            break;
        }
      },
      handleUpload(src, index) {
        this.$set(this.config.property_data, 'background_image', src);
      }
    }
  }

</script>
